<template>
  <div>
    <vs-dropdown style="float: right; cursor: pointer;" vs-custom-content vs-trigger-click>
      <vs-button v-if="params.data.checkDeletePermission" color="primary" type="border" icon-pack="feather" icon="icon-more-vertical"></vs-button>

      <vs-dropdown-menu>
        <vs-dropdown-item @click="openModal">Edit</vs-dropdown-item>
        <vs-dropdown-item @click="openConfirm">Delete</vs-dropdown-item>
        
      </vs-dropdown-menu>
    </vs-dropdown>
    <vs-popup title="Warning" :active.sync="additionalPopUp">
      <vs-list>
        <vs-list-item v-for="(item, index) in nonDeletableItems" :key="index" :title="item"></vs-list-item>
      </vs-list>
      <h3>The task you are about to delete belongs to a project. Do you want to proceed?</h3>
      <vs-button class="m-2" @click="haldleDelete(true)">Yes</vs-button>
      <vs-button class="m-2" @click="handleCancel">No</vs-button>
    </vs-popup>
  </div>
</template>

<script>
import { taskTemplateDelete, taskDelete } from '@/api/task-project.js'
import { mapActions } from 'vuex'
export default {
  name: 'CellRendererActions',
  data () {
    return {
      nonDeletableItems: [],
      additionalPopUp: false,
      decisionPopup: false,
      taskDelDes:'NO'
    }
  },
  methods: {
    ...mapActions([
      'SET_DELETE_ID',
      'SET_DELETE_LIVE_ID'
    ]),
    openModal () {
      this.params.colDef.filterParams.openModalSectionLive(this.params.data)
    },
    handleCancel(){
      this.additionalPopUp=false;
    },
    openConfirm () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are you sure you want to delete this task?',
        accept: this.haldleDelete
      })
    },
    async haldleDelete (data= false) {
    this.taskDelDes=data?'YES':'NO';
      const deleting_id = this.params.data.id
      const payload = {
        deleteFields: [deleting_id],
        are_you_want_to_delete:this.taskDelDes
      }
      if (this.params.data.reference_id === null || this.params.data.reference_id === '') {
        try {
          const data = await taskTemplateDelete(localStorage.getItem('customer_id'), payload)
          this.SET_DELETE_ID(deleting_id)
          this.$vs.notify({
            title: 'Task Deleted',
            text: 'Task Deleted Successfully',
            ...this.successProp()
          })
        } catch (error) {
          console.error(error)
          this.$vs.notify({
            title: 'Warning',
            text: error.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })

        }
      } else {
        try {
          const response = await taskDelete(localStorage.getItem('customer_id'), payload)
          
          if (response.status === 200 || response.status === 202) {
            if (response.data.data.status) {
              this.additionalPopUp = true
              this.nonDeletableItems = response.data.data.nonDeletableEntity.map(item => { return item.name })
            } else {
              this.SET_DELETE_LIVE_ID(deleting_id)
              this.additionalPopUp=false
              this.nonDeletableItems = response.data.data.nonDeletableEntity.map(item => { return item.name })
              this.$vs.notify({
                title: 'Task Deleted',
                text: 'Task Deleted Successfully',
                ...this.successProp()
              })
            }
          }
        } catch (error) {
          console.error(error)
          this.$vs.notify({
            title: 'Warning',
            text: error.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })

        }
      }
      
     
    }
  }
}


</script>